var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"width":"50%","visible":_vm.collectionVisible,"title":"收款明细","maskClosable":false,"footer":null},on:{"cancel":function($event){_vm.collectionVisible = false}}},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }